import { colorsPalettes, mixins } from "@similarweb/styles";
import styled from "styled-components";
import SelectionDropdownView from "../../../../table-actions-panel/components/SelectionDropdown/SelectionDropdown";

export const StyledSelectionDropdown = styled(SelectionDropdownView)`
    margin-left: 20px;
`;

export const StyledTitle = styled.span`
    ${mixins.setFontVariant("button", colorsPalettes.carbon["0"])};
    text-transform: capitalize;
    user-select: none;
`;
